import type { FC, ReactNode } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { QueryErrorAlert } from "./QueryErrorAlert";

interface DashboardChartCardProps {
  title: string;
  subheader?: string;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
  empty: boolean;
  height?: number;
  children: ReactNode;
}

const DEFAULT_HEIGHT = 320;

export const DashboardChartCard: FC<DashboardChartCardProps> = ({
  title,
  subheader,
  loading,
  error,
  onRetry,
  empty,
  height = DEFAULT_HEIGHT,
  children,
}) => {
  let body: ReactNode;
  if (error) {
    body = <QueryErrorAlert onRetry={onRetry} />;
  } else if (loading) {
    body = <Skeleton variant="rounded" height={height} />;
  } else if (empty) {
    body = (
      <Stack sx={{ height, alignItems: "center", justifyContent: "center" }}>
        <Typography color="text.secondary">Нет данных за период</Typography>
      </Stack>
    );
  } else {
    body = children;
  }

  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader
        title={title}
        subheader={subheader}
        slotProps={{ title: { variant: "subtitle1" } }}
      />
      <CardContent sx={{ pt: 0 }}>{body}</CardContent>
    </Card>
  );
};
